import { useState } from "react";
import { Upload } from "antd";
import { RAImage } from "../Image";

const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(img);
};

export const RAUpload = () => {
	const [loading, setLoading] = useState(false);
	const [imageUrl, setImageUrl] = useState();

	const handleChange = (info) => {
		if (info.file.status === "uploading") {
			setLoading(true);
			return;
		}
		if (info.file.status === "done") {
			// Get this url from response in real world.
			getBase64(info.file.originFileObj, (url) => {
				setLoading(false);
				setImageUrl(url);
			});
		}
	};

	const uploadButton = (
		<div
			style={{
				marginTop: 8,
			}}
		>
			Upload
		</div>
	);

	return (
		<Upload
			name="avatar"
			listType="picture-card"
			className="avatar-uploader"
			showUploadList={false}
			beforeUpload={() => false} // return false so that antd doesn't upload the picture right away
			onChange={handleChange}
		>
			{imageUrl ? <RAImage url={imageUrl} width="100%" /> : uploadButton}
		</Upload>
	);
};
